import { Observable } from 'rxjs';
import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Periode } from '../models/periode.model';
import { errorHandler } from '@angular/platform-browser/src/browser';
import { NbTokenService } from '@nebular/auth';
import { Recette } from '../models/recette.model';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token',
  }),
};
@Injectable({
  providedIn: 'root',
})
export class PeriodeService {
  
  baseUrl: string = 'http://localhost:3000';
  constructor(private httpClient: HttpClient, private nbTokenService: NbTokenService) { }

  async getPeriodes(recetteId: number): Promise<Periode[]> {
    let response = await this.httpClient
    .get(this.baseUrl + '/periode?id_recette=' + recetteId)
    .toPromise();
    return response as Periode[];
  }

  addPeriode (periode: Periode, periodes: Periode[], recetteId: number): Observable<Periode> {
    console.log(periodes);
    periodes.sort(function(obj1, obj2){
      return obj1.ordre - obj2.ordre;
    });
    periode.id_recette = recetteId;
    if (periodes.length > 0) {
      const lastOrdre = periodes[periodes.length - 1].ordre;
      periode.ordre = lastOrdre + 1;
    }else {
      periode.ordre = 1;
    }
    return this.httpClient.post<Periode>(this.baseUrl + '/periode', periode);
  }

  deletePeriode(periode: Periode, periodes: Periode[], recetteId: number) {
    this.httpClient.delete(this.baseUrl + '/periode/' + periode.id)
    .subscribe(
      data  => {
        console.log('POST Request is successful', data);
      },
        error  => {
        console.log('Error', error);
      },
    );
    for (let i = 0; i < periodes.length; i++) {
      if(periodes[i].ordre > periode.ordre) {
        periodes[i].ordre -= 1;
      }
    }
  }
}
